import React from 'react';
import { Placeholder } from 'vendors/semantic-ui';

import styles from './product-sort-list-component.module.css';

export const ProductSortListLoader: React.FC = () => {
    return (
        <div className={styles.selectLoaderContainer}>
            <Placeholder fluid>
                <Placeholder.Line className={styles.selectLoader} />
            </Placeholder>
        </div>
    );
};
